<script>
  import { Wizard } from '@client/components/wizard';
  import { Welcome, Create, Done } from './pages';
</script>

<Wizard steps={[Welcome, Create, Done]} showNavigation={false} validate={() => true} />

<style lang="scss" src="./getting-started.scss"></style>
